import React from 'react';
import { Switch, Router, Route } from 'react-router-dom';
import { connect } from 'react-redux';

import { history } from '../_helpers';
import { alertActions } from '../_actions';
import { PrivateRoute, PrivateAndPriviledgedRoute } from '../_components';
import { HomePage } from '../HomePage';
import { LoginPage } from '../LoginPage';
import { RegisterPage } from '../RegisterPage';
import { NavigationBar } from '../NavigationBar';
import { FooterBar } from '../FooterBar';
import { ProfilePage } from '../ProfilePage';
import { PasswordPage } from '../PasswordPage';
import { DeleteAccountPage } from '../DeleteAccountPage';
import { AdminPage } from '../AdminPage';
import { Recipes } from '../Recipes'
import { Ingredients } from '../Ingredients';
import { AddIngredient } from '../AddIngredient';
import { AddRecipe } from '../AddRecipe';
import { PartyTime } from '../PartyTime';
import { AboutPage } from '../AboutPage';
import { ForgotPassword } from '../ForgotPassword';
import { ResetPassword } from '../ResetPassword';
import { ContactForm } from '../ContactForm';

class App extends React.Component {
    constructor(props) {
        super(props);

        const { dispatch } = this.props;
        history.listen((location, action) => {
            // clear alert on location change
            dispatch(alertActions.clear());
        });
    }

    render() {
        const { alert, dispatch } = this.props;

        if (alert.message) {
            setTimeout(function(){
                dispatch(alertActions.clear());
            }, 5000)
        }
        return (
          <Router history={history}>
              <div>
              <NavigationBar />
                <div className="container">
                    {alert.message &&
                    <div className={`alert ${alert.type}`}>{alert.message}</div>
                    }
                    <Switch className="col-sm-8 col-sm-offset-2">
                        <Route exact path="/" component={HomePage} />
                        <PrivateAndPriviledgedRoute access_level="8" path="/admin" component={AdminPage} />
                        <PrivateRoute path="/profile" component={ProfilePage} />
                        <PrivateRoute path="/change_password" component={PasswordPage} />
                        <PrivateRoute path="/delete_account" component={DeleteAccountPage} />
                        <Route path="/recipe/:machine_name/edit" component={AddRecipe} />
                        <Route path="/recipe" component={Recipes} />

                        <PrivateAndPriviledgedRoute access_level="4" path="/ingredient/:machine_name/edit" component={AddIngredient} />
                        <PrivateAndPriviledgedRoute access_level="4" path="/ingredient" component={Ingredients} />

                        <PrivateAndPriviledgedRoute access_level="4" path="/add_recipe" component={AddRecipe} />
                        <PrivateAndPriviledgedRoute access_level="4" path="/add_ingredient" component={AddIngredient} />
                        <Route path="/about" component={AboutPage} />
                        <Route path="/login" component={LoginPage} />
                        <Route path="/party_time" component={PartyTime} />
                        <Route path="/register" component={RegisterPage} />
                        <PrivateRoute path="/edit_profile" component={RegisterPage} />
                        <Route path="/forgot_password" component={ForgotPassword} />
                        <Route path="/reset/:reset_token" component={ResetPassword} />
                        <Route path="/contact" component={ContactForm} />
                    </Switch>
                </div>
                <FooterBar />
              </div>
          </Router>
        );
    }
}

function mapStateToProps(state) {
    const { alert } = state;
    return {
        alert
    };
}

const connectedApp = connect(mapStateToProps)(App);
export { connectedApp as App }; 


// WEBPACK FOOTER //
// ./src/App/App.jsx